"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterSelectResultItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _Checkbox = require("../../Checkbox");

var _FilterSelectContext = require("./FilterSelectContext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterSelectResultItem = function FilterSelectResultItem(props) {
  var _useFilterSelectConte = (0, _FilterSelectContext.useFilterSelectContext)(),
      renderItemLabel = _useFilterSelectConte.renderItemLabel,
      selectedItems = _useFilterSelectConte.selectedItems,
      toggleSelectedItem = _useFilterSelectConte.toggleSelectedItem;

  var isSelected = !!selectedItems.find(function (item) {
    return item.value === props.value;
  });
  var label = renderItemLabel ? renderItemLabel(props) : props.label;
  return /*#__PURE__*/_react.default.createElement(_Checkbox.Checkbox, {
    onSelect: function onSelect() {
      return toggleSelectedItem(props);
    },
    selected: isSelected,
    key: props.value,
    my: 1
  }, label);
};

exports.FilterSelectResultItem = FilterSelectResultItem;
FilterSelectResultItem.displayName = "FilterSelectResultItem";
//# sourceMappingURL=FilterSelectResultItem.js.map